import { render, staticRenderFns } from "./AboutMembersIndex3.vue?vue&type=template&id=7cae2904&"
import script from "./AboutMembersIndex3.vue?vue&type=script&lang=js&"
export * from "./AboutMembersIndex3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports